import React, { useEffect, useState } from 'react'
import AdminNavbar from '../Navbar/AdminNavbar'
import { CustomerMasterFindAll,  MineMasterFindAll, ProductMasterFindAll } from '../Api/All_Api';
import axios from 'axios';
import { toast } from 'react-toastify';
import { RiBillFill } from "react-icons/ri";
import { Button, DatePicker, Input, Select, Spin, Table } from 'antd';
import dayjs from 'dayjs';
import { Option } from 'antd/es/mentions';
import { BillEntryPrintBill, MineMasterAssignedFindAll, RateGetByProductId, SaleEntry_ProductEntryDelete, SaleEntry_ProductEntryGetById, SaleEntryAdd, SaleEntryAdminFindAll, SaleEntryDelete, SaleEntryUpdate, SaleEntryUserFindAll } from '../Api/Transaction_Api';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { getReportDataApi } from '../Api/CommonApi';
import TitleNavbar from '../Navbar/TitleNavbar';

const BillingEntry = () => {


  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];
  const sessionYear = sessionStorage.getItem('sessionYear');
  const year = sessionYear;
  const userId = sessionStorage.getItem('userId');  
  const branchId = sessionStorage.getItem('branchId');  
  const isAdmin = sessionStorage.getItem('role');  
  
  const navigate = useNavigate();
      useEffect(() => {
        if (!sessionYear) {
          sessionStorage.clear();
          navigate('/')
        }
      },[])


  const [errors, setErrors] = useState({
    billDate: "",
    mineName: "",
    customerName: "",
    vehicleNo: "",
    paymentStatus: "",
    paymentMethod: "",
    transferTo: "",
    transactionId: "",
  });

  const [productEntryAddError, setProductEntryAddError] = useState({
    productName: "",
    quantity: "",
    rate: "",
    amount: "",
  });


  const [pageSize, setPageSize] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const [saleBillNo, setSaleBillNo] = useState("");
  const [saleEntryId, setSaleEntryId] = useState("");
  const [billDate, setBillDate] = useState(dayjs());
  const [mineName, setMineName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");

  const [productName, setProductName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rate, setRate] = useState("");
  const [amount, setAmount] = useState("");

  const [paymentStatus, setPaymentStatus] = useState("Pending");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [transferTo, setTransferTo] = useState("");
  const [transactionId, setTransactionId] = useState("");

  const [allMine, setAllMine] = useState([]);
  const [allCustomer, setAllCustomer] = useState([]);
  const [allProduct, setAllProduct] = useState([]);

  const [allSaleEntry, setAllSaleEntry] = useState([]);
  const [productEntryData, setProductEntryData] = useState([])
  const [updateButton, setUpdateButton] = useState(false);
  const [saveButton, setSaveButton] = useState(true);
  const [loadingId, setLoadingId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showTable, setShowTable] = useState(true);

  const handleShowForm = () => {
    setShowTable(false);
    setShowForm(true);
  };

    //======Search data from table===============
    const handleSearch = (value) => {
      const filtered = allSaleEntry.filter((item) =>
        Object.values(item).some((val) =>
          val !== null && val !== undefined && val.toString().toLowerCase().includes(value.toLowerCase())
        )
      );
      setFilteredData(filtered);
      setTotalEntries(filtered.length); // Update total entries count after filtering
      setCurrentPage(1);
    };
    //==========Pagination=======================
    const handlePageSizeChange = (value) => {
      setPageSize(value);
    };

  // Fetch Cast Names
  let isSalentryFetched = false;
  useEffect(() => {
    if (isSalentryFetched) return;
    fetchSaleEntry();
    fetchMineNames();
    fetchProductNames();
    fetchCustomerNames();
    isSalentryFetched = true;
  }, []);

  const fetchCustomerNames = async () => {
  
    try {
      const response = await axios.get(`${CustomerMasterFindAll}?branchId=${branchId}`);
      if (response.data !== null) {
        setAllCustomer(response.data);
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Customers:", error);
        toast.error("Failed to fetch Customers data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };

  const fetchMineNames = async () => {
  
    try {

      if (isAdmin==1) {
        const response = await axios.get(`${MineMasterFindAll}`);
        if (response.data !== null) {
          setAllMine(response.data);
        }
      }
      else {
        const response = await axios.get(`${MineMasterAssignedFindAll}?id=${userId}&branchId=${branchId}&accYear=${year}`);
        if (response.data !== null) {
          setAllMine(response.data);
        }
      }
     
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Mines:", error);
        toast.error("Failed to fetch Mines data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };

  const fetchProductNames = async () => {
  
    try {
      const response = await axios.get(`${ProductMasterFindAll}?branchId=${branchId}`);
      if (response.data !== null) {
        setAllProduct(response.data);
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Product:", error);
        toast.error("Failed to fetch Product data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };

  // ==============Get Main Table Data================

  let isError = false;

  const fetchSaleEntry = async () => {
    try {
    if (isAdmin==1) {

        const response = await axios.get(`${SaleEntryAdminFindAll}?branchId=${branchId}&accYear=${year}`);
        if (response.data !== null) {
          setAllSaleEntry(response.data);
          setFilteredData(response.data); // Set initial filtered data as the fetched data
          setTotalEntries(response.data.length); // Set the total number of entries
        }
       
    }
    else{
    
        const response = await axios.get(`${SaleEntryUserFindAll}?id=${userId}&branchId=${branchId}&accYear=${year}`);
        if (response.data !== null) {
          setAllSaleEntry(response.data);
          setFilteredData(response.data); // Set initial filtered data as the fetched data
          setTotalEntries(response.data.length); // Set the total number of entries
        }
    }
  }
    catch (error) {
      if (!isError) {
        // Check if the error has already been triggered
        console.error("Error fetching Billing Entry:", error);
        toast.error("Failed to fetch Billing Entry data");
        isError = true; // Set the flag to prevent double toast
      }
    }
 
    
  };

  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Bill No",
      dataIndex: "saleBillNo",
      key: "saleBillNo",
    },
    {
      title: "Mine Name",
      dataIndex: "mineName",
      key: "mineName",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Vehicle No",
      dataIndex: "vehicleNo",
      key: "vehicleNo",
    },
 
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
    },

    {
      title: "Edit",
      key: "edit",
      render: (text, record) => (
        <div className=''>
          <span className='me-1 me-lg-2'
            type="submit"
            id={`edit-tooltip-${record.id}`}
            style={{ fontSize: "12px", color: "orange", }}
            onClick={() => handleEditSaleEntry(record)}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </span>
          <Tooltip
          anchorId={`edit-tooltip-${record.id}`}
          content="Edit"
          place="top"
        />
        </div>
      ),
    },

    {
      title: "Delete",
      key: "delete",
      render: (text, record) => (
        <div className=''>
          <span className='me-1 me-lg-2'
            type="submit"
            id={`delete-tooltip-${record.id}`}
            style={{ fontSize: "12px", color: "red", }}
            onClick={() => handleDeleteData(record)}
          >
            <i class="fa-solid fa-trash"></i>
          </span>
          <Tooltip
          anchorId={`delete-tooltip-${record.id}`}
          content="Delete"
          place="top"
        />
        </div>
      ),
    },

    // {
    //   title: "Print",
    //   key: "print",
    //   render: (text, record) => (
    //     <div className=''>
    //       <span className='me-1 me-lg-2'
    //         type="submit"
    //         id={`print-tooltip-${record.id}`}
    //         style={{ fontSize: "12px", color: "blue", }}
    //         onClick={() => handlePrintData(record)}
    //       >
    //         <i class="fa-solid fa-print"></i>
    //       </span>
    //       <Tooltip
    //       anchorId={`print-tooltip-${record.id}`}
    //       content="Print"
    //       place="top"
    //     />
    //     </div>
    //   ),
    // },
    {
      title: "Print",
      key: "print",
      render: (text, record) => (
        <div>
          <span
            className='me-1 me-lg-2'
            id={`print-tooltip-${record.id}`}
            style={{
              fontSize: "12px",
              color: loadingId === record.id ? "gray" : "blue",
              cursor: loadingId === record.id ? "not-allowed" : "pointer",
            }}
            onClick={() => !loadingId && handlePrintData(record)} // Prevent clicks while loading
          >
            {loadingId === record.id ? (
              <Spin size="small" />
            ) : (
              <i className="fa-solid fa-print"></i>
            )}
          </span>
          <Tooltip
            anchorId={`print-tooltip-${record.id}`}
            content="Print"
            place="top"
          />
        </div>
      ),
    },
  ];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };

// ============Add Product Entry Data================
const [isEditing, setIsEditing] = useState(false); // To toggle Add/Update button
const [editIndex, setEditIndex] = useState(null); // To track the index of the row being edited

const handleAddProductEntry = () => {

  const totalAmount = productEntryData.reduce((sum, row) => sum + row.amount, 0);

  let isProductEntryValid = true;
  const productEntryErrorObj = {};

  if (!productName) {
    isProductEntryValid = false;
    productEntryErrorObj.productName = "Product Name is required *";
  }
  if (!quantity) {
    isProductEntryValid = false;
    productEntryErrorObj.quantity = "Quantity is required *";
  }
  if (!rate) {
    isProductEntryValid = false;
    productEntryErrorObj.rate = "Rate is required *";
  }
  if (!amount) {
    isProductEntryValid = false;
    productEntryErrorObj.amount = "Amount is required *";
  }

  setProductEntryAddError(productEntryErrorObj);

  if (!isProductEntryValid) return;

  const newRow = {
    productId:parseInt(productName),
    quantity:parseInt(quantity),
    rate:parseInt(rate),
    total:parseInt(amount),
    branchId: parseInt(branchId),
    accYear: parseInt(year),
  };

  setProductEntryData([...productEntryData, newRow]); // Add new row to table data

  // Reset form fields
  setProductName("");
  setQuantity("");
  setRate("");
  setAmount("");
};

const handleUpdateProductEntry = () => {
  if (editIndex !== null) {
    const updatedData = [...productEntryData];

    // Retain the existing id of the row being updated
    const existingId = updatedData[editIndex]?.id || null;

    updatedData[editIndex] = {
      id: existingId, // Keep the same id
      productId: parseInt(productName),
      quantity: parseInt(quantity),
      rate: parseFloat(rate),
      total: parseFloat(amount),
      branchId: parseInt(branchId),
      accYear: parseInt(year),
    };
    setProductEntryData(updatedData);
    setIsEditing(false); // Switch back to Add mode
    setEditIndex(null); // Reset index
    setProductName("");
    setQuantity("");
    setRate("");
    setAmount("");
    toast.success("Product data updated successfully!");
  }
};

const handleEditRow = (row, index) => {
  setProductName(row.productId);
  setQuantity(row.quantity);
  setRate(row.rate);
  setAmount(row.total);
  setIsEditing(true);
  setEditIndex(index); // Save the index of the row being edited
};

const handleDeleteRow = async (rowId,index) => {
  const rowToDelete = rowId.id;

  if (rowToDelete) {
    try {
      // Call delete API for the row
      const deleteResponse = await axios.delete(`${SaleEntry_ProductEntryDelete}?id=${rowToDelete}`);
      
      if (deleteResponse.data === "DELETED") {
        toast.success("Product data deleted successfully");
        
          // Refresh the table data by removing the deleted row
      const updatedData = productEntryData.filter((_, i) => i !== index);
      setProductEntryData(updatedData);

      } else {
        toast.error("Failed to delete the row");
      }
    } catch (error) {
      console.error("Error deleting row:", error);
      toast.error("Error occurred while deleting the row");
    }
  } else {
    // For unsaved rows, just remove them from the table
    const updatedData = productEntryData.filter((_, i) => i !== index);
    setProductEntryData(updatedData);
    toast.success("Row removed successfully");
  }
};

const handleCancelProductEntry= () => {
  setProductName("");
  setQuantity("");
  setRate("");
  setAmount("");

  setProductEntryAddError("");
 }

  //========SAVE MAIN TABLE DATA=============

  const handleFormSave = async () => {

    const totalAmount = productEntryData.reduce((sum, row) => sum + row.total, 0);
    let pendingAmount;
    let recievedAmount;
    let isValid = true;
    const errorObj = {};

    if (!billDate) {
      isValid = false;
      errorObj.billDate = "Bill Date is required *";
    }
    if (!mineName) {
      isValid = false;
      errorObj.mineName = "Mine Name is required *";
    }
    if (!customerName) {
      isValid = false;
      errorObj.customerName = "Customer Name is required *";
    }
    if (!vehicleNo) {
      isValid = false;
      errorObj.vehicleNo = "Vehicle No is required *";
    }
   

    setErrors(errorObj);

    if (!isValid) return;

    const formattedBillDate = billDate
      ? dayjs(billDate).format("DD/MM/YYYY")
      : "";
   
      if (paymentStatus === "Paid") {
        recievedAmount = totalAmount;
        pendingAmount = 0;
      } else if (paymentStatus === "Pending") {
        recievedAmount = 0;
        pendingAmount = totalAmount;
      } else {
        recievedAmount = 0;
        pendingAmount = totalAmount; // Default to full pending
      }
    // Prepare data for the first API call (for memberTypeName and returnDays)
    const saleEntryData = {      
      date:formattedBillDate,
      mineId:parseInt(mineName),
      customerId:customerName,
      accYear:year,
      vehicleNo:vehicleNo,
      totalAmount:totalAmount,
      paymentStatus:paymentStatus || null,
      paymentMode:paymentMethod || null,
      transferedTo:transferTo || 0,
      transactionId:transactionId || 0,
      saleEntry:productEntryData,
      accYear:parseInt(year),
      branchId:parseInt(branchId),
      pendingAmount:pendingAmount,
      receievedAmount:recievedAmount,
    };
  
    try {
      // Call the first API for memberTypeName and returnDays
      const saleEntryResponse = await axios.post(`${SaleEntryAdd}?branchId=${branchId}&accYear=${year}`, saleEntryData);
  
      if (saleEntryResponse.data === "CREATED") {
        toast.success("Sale Entry Saved Successfully");
        handleCancel();
      }      
  
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed to save data");
    }
  };
  const handleEditSaleEntry = (data) => {
    setSaveButton(false)
    setUpdateButton(true)
    setShowForm(true)
    setShowTable(false)

    handleEditData(data.saleBillNo)
   };  
  const handleEditData = async (selectedId) => {
    try {
      const response = await axios.get(`${SaleEntry_ProductEntryGetById}?id=${selectedId}&branchId=${branchId}&accYear=${year}`);
      const SaleEntryDataArray = response.data;

      if (Array.isArray(SaleEntryDataArray) && SaleEntryDataArray.length > 0) {
        const SaleEntryData = SaleEntryDataArray[0];

      setSaleEntryId(SaleEntryData.id);
      setSaleBillNo(SaleEntryData.saleBillNo);
      setMineName(SaleEntryData.mineId || '');
      setCustomerName(SaleEntryData.customerId || '');
      setVehicleNo(SaleEntryData.vehicleNo || '');
      setTransactionId(SaleEntryData.transactionId || '');
      setTransferTo(SaleEntryData.transferedTo || '');
      setPaymentStatus(SaleEntryData.paymentStatus || '');
      setPaymentMethod(SaleEntryData.paymentMode || '');
      setBillDate(SaleEntryData.date ? dayjs(SaleEntryData.date, 'DD/MM/YYYY') : null);
  
      // Set the productEntryData (which is the table data)
      setProductEntryData(SaleEntryData.saleEntry || []);
  
  } else {
    toast.error("No data found for the selected ID");
  }

    } catch (error) {
      console.error("Error getting data:", error);
      toast.error("Failed to get sale entry data");
    }
  }
  const handleFormUpdate = async () => {
    const totalAmount = productEntryData.reduce((sum, row) => sum + row.total, 0);
 let pendingAmount;
 let recievedAmount;
    let isValid = true;

    const errorObj = {};

    if (!billDate) {
      isValid = false;
      errorObj.billDate = "Bill Date is required *";
    }
    if (!mineName) {
      isValid = false;
      errorObj.mineName = "Mine Name is required *";
    }
    if (!customerName) {
      isValid = false;
      errorObj.customerName = "Customer Name is required *";
    }
    if (!vehicleNo) {
      isValid = false;
      errorObj.vehicleNo = "Vehicl No is required *";
    }

    setErrors(errorObj);

    if (!isValid) return;
    if (paymentStatus === "Paid") {
      recievedAmount = totalAmount;
      pendingAmount = 0;
    } else if (paymentStatus === "Pending") {
      recievedAmount = 0;
      pendingAmount = totalAmount;
    } else {
      recievedAmount = 0;
      pendingAmount = totalAmount; // Default to full pending
    }
    const formattedBillDate = billDate
      ? dayjs(billDate).format("DD/MM/YYYY")
      : "";

      const formattedProductEntryData = productEntryData.map((row) => ({
        id: row.id || 0,
        saleBillNo:parseInt(saleBillNo),
        productId:parseInt(row.productId),
        quantity: parseInt(row.quantity),
        rate: parseInt(row.rate),                                                                      
        total: parseInt(row.total),
        branchId: parseInt(branchId),
        accYear: parseInt(year),
      }));


    // Prepare data for the first API call (for memberTypeName and returnDays)
    const saleEntryUpdateData = {      
      id:saleEntryId,
      date:formattedBillDate,
      mineId:parseInt(mineName),
      customerId:customerName,
      accYear:parseInt(year),
      vehicleNo:vehicleNo,
      saleBillNo:saleBillNo,
      totalAmount:totalAmount,
      paymentStatus:paymentStatus || null,
      paymentMode:paymentMethod || null,
      transferedTo:transferTo || 0,
      transactionId:transactionId || 0,
      saleEntry:formattedProductEntryData,
      pendingAmount:pendingAmount,
    };
  
    try {
      // Call the first API for memberTypeName and returnDays
      const saleEntryResponse = await axios.put(`${SaleEntryUpdate}?branchId=${branchId}&accYear=${year}`, saleEntryUpdateData);

      if (saleEntryResponse.data === "UPDATED") {
        toast.success("Sale Entry Updated Successfully");
        handleCancel();
      }       
  
    } catch (error) {
      console.error("Error updating data:", error);
      toast.error("Failed to update data");
    }
  };

  //========CANCEL MAIN TABLE INPUT FIELD DATA=============
  const handleCancel = () => {
    handleCancelProductEntry();
    handleCancelForm();
    fetchSaleEntry();
  };

  const handleCancelForm = () => {
    setShowForm(false);
    setShowTable(true);
    setSaveButton(true)
    setUpdateButton(false)
    setBillDate(dayjs());
    setVehicleNo("");
    setMineName("");
    setCustomerName("");
    setPaymentMethod("");
    setPaymentStatus("Pending");
    setTransactionId("");
    setTransferTo("");
    setProductEntryData([]);
    setErrors("");
    handleCancelProductEntry("");
    setProductEntryAddError("");
    fetchSaleEntry();
  };

  const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the Billing Entry "${item.customerName}"?`
    );
    if (!confirmDelete) return;
    console.log("Payment Status",item.paymentStatus);
 if(item.paymentStatus === "Pending"){
    try {
      const response = await axios.delete(
        `${SaleEntryDelete}?saleBillNo=${item.saleBillNo}&branchId=${branchId}&accYear=${year}`
      );
      if (response.data === "DELETED") {
        toast.success("Bill deleted !");
        handleCancel();
        fetchSaleEntry();
      }
      else if(response.data === "NOTFOUND"){
        toast.error("Bill is not found");
        handleCancel();
        fetchSaleEntry();
      }
      else if(response.data === "EXISTED"){
        toast.warn("Bill amount is partially paid ", {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        handleCancel();
        fetchSaleEntry();
      }

      
    } catch (error) {
      console.error("Error during delete operation:", error);
      toast.error("Error occurred while deleting the Assigned Mine");
    }}
 else{
      toast.warn("Bill cannot be deleted", {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  //===================================


const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================

const handlePrintData = async (record) => {
  setLoadingId(record.id);
  try {
    // Make an API call to fetch the PDF name or URL
    const response = await axios.get(`${BillEntryPrintBill}?branchId=${branchId}&accYear=${year}&saleBillNo=${record.saleBillNo}`);

    const pdfFileName = response.data
    if(response.data === "NOTFOUND"){
      toast.warn('Data Not Found...!!', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }

   else if (pdfFileName) {
        const pdfUrl = getReportDataApi + `output/${pdfFileName}`
        window.open(pdfUrl, '_blank')

    } else if(response.data == 'UNAUTHORIZED'){
      toast.warn('Your data is UNAUTHORIZED!!', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      sessionStorage.clear();
      navigate("/"); 
    }  else {
        console.error('Invalid PDF URL')
    }
  } catch (error) {
    console.error("Error fetching PDF:", error);
    alert("An error occurred while fetching the PDF.");
  }
  finally{
    setLoadingId(null);
  }
};

//=====================================================

  return (
    <>
      <AdminNavbar />

    <div className="p-0 m-0">

        <div
          className="row m-0"
          style={navbg}
        >
          <div
            className="col-12 "
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <span className="px-md-5" style={{ flexGrow: 1}}>
            {" "}
              <RiBillFill /> &nbsp; Billing Entry
            </span>
            <span >
            <TitleNavbar/>
            </span>
          </div>

  
        </div>

        {showForm && (
          <>
        <div className='row m-0 pt-2'>
          <div className='col-12 col-lg-2'></div>
          <div className='col-12 col-lg-8'>
              <div className="row px-md-5 mt-3 m-0 mb-5 py-3">

              {/* <div className='col-12 col-lg-8'>
                <div className='row m-0'> */}

                      <div className="col-12 col-md-6 col-lg-3 pt-2">
                          <label className="labels">Date</label>
                          <div className="row m-0 ">
                                <DatePicker
                                  value={billDate}
                                  onChange={(value) => setBillDate(value)}
                                  className="w-100 "
                                  format={dateFormatList}
                                />
                                {errors.billDate && (
                                  <div className="errorField">{errors.billDate}</div>
                                )}
                            </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-3 pt-2">
                      <label className="labels">Mine</label>
                        <div className="row">
                                                <Select
                                                  value={mineName || undefined}
                                                  onChange={setMineName}
                                                  showSearch
                                                  className="w-100"
                                                  placeholder="Select Mine"
                                                  optionFilterProp="children"
                                                >
                                                  {allMine.map((mine) => (
                                                    <Option key={mine.id} value={mine.mineId}>
                                                      {mine.mineName}
                                                    </Option>
                                                  ))}
                                                </Select>
                                                {errors.mineName && (
                                                  <div className="errorField">{errors.mineName}</div>
                                                )}
                        </div>
                      </div>
                {/* </div> */}
                {/* <div className='row m-0'> */}
                      <div className="col-12 col-md-6 col-lg-3 pt-2">
                        <label className="labels p-0">Customer</label>
                      <div className="row  ">
                        <Select
                                                value={customerName || undefined}
                                                onChange={setCustomerName}
                                                showSearch
                                                className="w-100"
                                                placeholder="Select Customer"
                                                optionFilterProp="children"
                                              >
                                                {allCustomer.map((customer) => (
                                                  <Option key={customer.id} value={customer.id}>
                                                    {customer.customerName}
                                                  </Option>
                                                ))}
                                              </Select>
                                              {errors.customerName && (
                                                <div className="errorField">{errors.customerName}</div>
                                              )}
                      </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-3 pt-2">
                          <label className="labels">Vehicle No</label>
                          <div className="row m-0 ">
                            <Input
                                value={vehicleNo || ''}
                                onChange={(e) => setVehicleNo(e.target.value)}
                                placeholder="Enter Vehicle No"
                              />
                              {errors.vehicleNo && (
                                <div className="errorField">{errors.vehicleNo}</div>
                              )}
                          </div>
                      </div>
                {/* </div> 
              </div>  */}

              <div className="row p-0 m-0 shadow rounded mt-3 py-2 border" style={{backgroundColor:"white"}}>
    
                  <div className="col-12 col-md-6 col-lg-3 pt-2">
                      <label className="labels">Product Name :</label>
                      <div className="row">
                    <Select
                            value={productName || undefined}
                            onChange={async (value) => {
                              setProductName(value);
                              
                              // Find the selected product
                              const selectedProduct = allProduct.find((product) => product.id === value);
                              
                              if (selectedProduct) {
                                try {
                                  // API call to fetch rate using the selected product ID and billDate
                                  const response = await axios.get(`${RateGetByProductId}?id=${selectedProduct.id}&branchId=${branchId}`);

                                  if (response.data) {
                                    const fetchedRate = response.data[0].price;

                                    // Set the rate and update the amount if quantity is already entered
                                    setRate(fetchedRate);
                                    setAmount(fetchedRate * (quantity || 0));
                                  }
                                } catch (error) {
                                  console.error("Error fetching rate:", error);
                                  setRate("")
                                  toast.warn("Rate is not assigned to this product");
                                }
                              }
                            }}
                            showSearch
                            className="w-100"
                            placeholder="Select Product"
                            optionFilterProp="children"
                          >
                            {allProduct.map((product) => (
                              <Option key={product.id} value={product.id}>
                                {product.productName}
                              </Option>
                            ))}
                          </Select>

                          {productEntryAddError.productName && (
                          <div className="errorField">{productEntryAddError.productName}</div>
                        )}

                    </div>

                  </div>              
             
                  <div className="col-12 col-md-6 col-lg-3 pt-2">
                      <label className="labels">Quantity :</label>                
                      <div className="row m-0">
                        <Input
                          value={quantity || ''}
                          onChange={(e) => {
                            const qty = parseInt(e.target.value, 10) || 0;
                            setQuantity(qty);
                            // Update total amount when quantity changes
                            setAmount(qty * (rate || 0));
                          }}
                          placeholder="Enter Quantity"
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />

                        {productEntryAddError.quantity && (
                          <div className="errorField">{productEntryAddError.quantity}</div>
                        )}
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-3 pt-2">
                      <label className="labels">Rate :</label>
                      <div className="row m-0 ">
                        <Input
                          value={rate || ''}
                          onChange={(e) => {
                            const newRate = parseFloat(e.target.value) || 0;
                            setRate(newRate);
                            // Update total amount when rate changes
                            setAmount(newRate * (quantity || 0));
                          }}
                          placeholder="Enter Rate"
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                        {productEntryAddError.rate && (
                          <div className="errorField">{productEntryAddError.rate}</div>
                        )}
                    </div>
                  </div>             

                  <div className="col-12 col-md-6 col-lg-3 pt-2">
                      <label className="labels">Amount :</label>
                      <div className="row m-0">
                        <Input
                          value={amount || ''}
                          onChange={(e) => setAmount(e.target.value)}
                          placeholder="Enter Amount"
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          readOnly 
                        />

                        {productEntryAddError.amount && (
                          <div className="errorField">{productEntryAddError.amount}</div>
                        )}
                    </div>
                  </div>

                  <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancelProductEntry}
                  >
                    Cancel
                  </Button>
                  {isEditing ? (
                      <Button
                        type="submit"
                        className="SubmitBtn mx-1"
                        onClick={handleUpdateProductEntry}
                      >
                        Update
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        className="SubmitBtn mx-1"
                        onClick={handleAddProductEntry}
                      >
                        Add
                      </Button>
                    )}
          
                 
                  </div>

              </div>

                {/* ======Table for Product Entry===== */}
                  <div className="col-12 mt-3 pb-3 p-0" style={{ backgroundColor: "white",}}>
                    <table className="w-100 shadow border " style={{ overflowX:"auto"}}>
                      <thead>
                        <tr style={{ backgroundColor: "#000", color: "#fff", }}>
                          <th className='px-2 py-1'>Product Name</th>
                          <th>Quantity</th>
                          <th>Rate</th>
                          <th>Amount</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody style={{ backgroundColor: "#fff", color: "#000" }}>
                        {productEntryData.map((row, index) => {
                          const productEntryObj = allProduct.find((type) => type.id == row.productId);

                          return ( 
                            <tr key={index}>
                              <td className='px-2' style={{ fontSize: "14px" }}>{productEntryObj ? productEntryObj.productName : "Unknown"}</td>
                              <td style={{ fontSize: "14px" }}>{row.quantity}</td>
                              <td style={{ fontSize: "14px" }}>{row.rate}</td>
                              <td style={{ fontSize: "14px" }}>{row.total}</td>
                              <td>
                                <span
                                  type="submit"
                                  style={{ fontSize: "12px", color: "orange", marginLeft: "10px" }}
                                  onClick={() => handleEditRow(row, index)}
                                >
                                  <i className="fa-solid fa-edit"></i>
                                </span> &nbsp; &nbsp;
                                <span
                                  type="submit"
                                  style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
                                  onClick={() => handleDeleteRow(row, index)}
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </span>
                              </td>
                            </tr>
                          );
                        })}
    
                      </tbody>
                    </table>
                  </div>
               

                <div className="col-12 col-md-6 col-lg-3 pt-2">
                        <label className="labels">Billing Amount</label>                      
                      <div className="row m-0 border rounded px-3" style={{backgroundColor:"#e5e5e5",padding:"3px 0px"}}>
                          {productEntryData.reduce((sum, row) => sum + row.total, 0)} 
                      </div>
                </div>                    


                  <div className="col-12 col-md-6 col-lg-3 pt-2">
                        <label className="labels">Payment</label>                
                          <div className="row">

                            <Select
                                value={paymentStatus || undefined}
                                onChange={(value) => setPaymentStatus(value)}
                                showSearch
                                className="w-100"
                                placeholder="Select Status"
                                optionFilterProp="children"
                              >
                                <Option value="Pending">Pending</Option>
                                <Option value="Paid">Paid</Option>
                              </Select>
                              {errors.paymentStatus && (
                                <div className="errorField">{errors.paymentStatus}</div>
                              )}

                          </div>
                  </div>

                    {/* Payment Method Dropdown (only visible when "Pay" is selected) */}
                    {paymentStatus == "Paid" && (
                      <div className="col-12 col-md-6 col-lg-3 pt-2">
                            <label className="labels">Payment Method</label>
                            <div className="row">
                            <Select
                              value={paymentMethod || undefined}
                              // onChange={(value) => setPaymentMethod(value)}
                              onChange={(value) => {
                                setPaymentMethod(value); // Set the selected payment method
                                setTransactionId(''); // Clear the transaction ID
                                setTransferTo(''); // Clear the transferTo value
                              }}
                              showSearch
                              className="w-100"
                              placeholder="Select Method"
                              optionFilterProp="children"
                            >
                                <Option value="Cash">Cash</Option>
                                <Option value="Upi">UPI</Option>
                            </Select>
                            {errors.paymentMethod && (
                              <div className="errorField">{errors.paymentMethod}</div>
                            )}

                          </div>
                        </div>
                    )}   
                      
                                  {/* UPI Fields (only visible when "UPI" is selected) */}
                    {paymentMethod == "Upi" && (                  
                        <>
                         <div className="col-12 col-md-6 col-lg-3 pt-2">
                              <label className="labels">Transfer To:</label>
                              <div className="row m-0">
                              <Input
                                  value={transferTo || ''}
                                  onChange={(e) => setTransferTo(e.target.value)}
                                  placeholder="Enter Transfer To"
                                />
                                {errors.transferTo && (
                                  <div className="errorField">{errors.transferTo}</div>
                                )}

                            </div>
                          </div>

                          <div className="col-12 col-md-6 col-lg-3 pt-2">
                              <label className="labels">Transaction ID:</label>
                              <div className="row m-0">
                            <Input
                                  value={transactionId || ''}
                                  onChange={(e) => setTransactionId(e.target.value)}
                                  placeholder="Enter Transaction Id"
                                />
                                {errors.transactionId && (
                                  <div className="errorField">{errors.transactionId}</div>
                                )}
                            </div>
                          </div>
                      </>
                    )}

                <div
                  className="col-12 p-0 mt-3"
                  style={{ borderBottom: "2px solid #bfb597" }}
                ></div>

                  {/* ============MAIN FORM BUTTONS================== */}
                <div className="col-12 text-center pt-3 mb-5">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancelForm}
                  >
                    Cancel
                  </Button>
                  {saveButton && (
                    <Button
                      type="submit"
                      className="SubmitBtn mx-1"
                      onClick={handleFormSave}
                    >
                      Save
                    </Button>
                  )}
                  {updateButton && (
                    <Button
                      type="submit"
                      className="UpdateBtn mx-1"
                      onClick={handleFormUpdate}
                    >
                      Update
                    </Button>
                  )}
                </div>

               
              </div>
          </div>
          <div className='col-12 col-lg-2'></div>

        </div>
        
        </>
        )}
        {/*================ Table =========================*/}
        {showTable && (
          <>
        <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
        <div className='col-12 col-lg-2'></div>
          <div  className="col-12 col-lg-8 py-3 shadow border"
            style={{ marginBottom: "50px", backgroundColor: "white" }}
          >

              <div className="row ps-2 m-0 mb-2">
                  <div className="col-12 col-md-3 col-lg-1">
                    <Button
                      onClick={handleShowForm}
                      style={{ backgroundColor: "#f8bf28" }}
                    >
                      Add New +
                    </Button>
                  </div>
                  <div className="col-12 col-md-9 col-lg-11"></div>
                </div>

            <div
              className="col-12 px-md-5"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                <Select
                  defaultValue={pageSize}
                  onChange={handlePageSizeChange}
                  style={{ width: 120, textAlign: "center" }}
                >
                  <Option value={10}>10</Option>
                  <Option value={20}>20</Option>
                  <Option value={30}>30</Option>
                </Select>
              </div>

              <div className="pt-4 pt-md-0">
                <Input.Search
                  placeholder="Search"
                  onSearch={handleSearch}
                  style={{ width: 200, marginBottom: 16 }}
                />
              </div>
            </div>

            <div style={{ backgroundColor: "white" }}>
              <Table
                bordered
                style={{ padding: "0px 20px", overflowX: "auto" }}
                columns={columns}
                dataSource={filteredData}
                pagination={{
                  pageSize: pageSize,
                  total: totalEntries,
                  showTotal: (total, range) =>
                    `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                  current: currentPage,
                  onChange: (page) => setCurrentPage(page),
                }}
                showSorterTooltip={false}
                rowKey={(record) => record.id}
                components={components}
              />
            </div>
          </div>
          <div className='col-12 col-lg-2'></div>
        </div>
        </>
        )}

      </div>

    </>
  )
}

export default BillingEntry